import { HttpClient } from "../../services/http/http-client";

export const PluginsService = {
  findAll: ({ plugins_section = "Booking" }) => {
    return HttpClient.get("/plugins.pl", {
      section: "plugins",
      action: "get_section_plugins",
      plugins_section,
      output: "json"
    });
  },
  activatePlugin: ({
    plugins_section = 'Booking',
    plugin_id,
  }) => {
    return HttpClient.post("/plugins.pl", {
      section: 'plugins',
      action: 'activate_selected_plugin',
      plugins_section,
      plugin_id,
    })
  }

};
